import {useEffect, useState} from 'react';
import * as actions from '../../../store/extractor/metaData/action'
import * as dbExtractor from '../../../store/extractor/actions'
import * as profileData from "../../../store/auth/selectors";
import {useDispatch, useSelector} from "react-redux";
import * as jobScheduleTrigger from '../../../store/jobSchedules/action'
import * as eventBasedTrigger from '../../../store/events/actions'
import * as eventTasks from '../../../store/eventBasedTrigger/actions'
import * as webhookAction from '../../../store/webhooks/actions'
import {putExtractorSelector} from "../../../store/extractor/selectors";
import {ITaskListParams} from '../../../store/eventBasedTrigger/types'
import ConfigureTablesForm from './extractorDetailsForm'
import format from 'date-fns/format';
import * as constants from '../../../constants/_pickerValues';

const CreateExtractorComponent = () => {
    const dispatch = useDispatch();
    const profile = useSelector(profileData.getProfileDataSelector)
    const email: string = profile !== null ? profile?.mail : 'Could not load email'
    const [triggerList, setTriggerList] = useState<[]>([])
    const [editTriggerList, setEditTriggerList] = useState<[]>([])
    const [editInboundWebhookList, setEditInboundWebhookList] = useState<[]>([])
    const [actionList, setActionList] = useState<[]>([])
    const [editActionList, setEditActionList] = useState<[]>([])
    const [inboundWebhookList, setInboundWebhookList] = useState<[]>([])
    const [eventList, setEventList] = useState<[]>([])
    const [eventEditList, setEditEventList] = useState<[]>([])
    const [loaderList, setLoaderList] = useState<[]>([])
    const [loaderEditList, setEditLoaderList] = useState<[]>([])
    const [database, setDatabase] = useState('')
    const [batchCode, setBatchCode] = useState('')
    const [eventTask, setEventTask] = useState<any>();
    const [tableLayerName, setTableLayerName] = useState<any>();

    const extractorResult = useSelector(putExtractorSelector)
// ***********************   STEP 5 - Get Batch Code and execute triggers and actions ********************************

    // This runs after custom extractor executed

    useEffect(() => {
        if (extractorResult) {
            const params: ITaskListParams = {
                taskType: "Extract_Task",
                taskCode: batchCode
            };
            dispatch(eventTasks.fetchTaskListReq(params));

            // get triggers that are existing time based jobs
            if (editTriggerList.length > 0) {
                const timeBased = editTriggerList.map((item: any, index: number) => {
                    return {
                        timezone: item.timezone ? item.timezone.replace(" UTC", "") : `${format(new Date(), 'xxx')}`,
                        cronExpression: item.cronExpression,
                        enabled: true,
                        owner: email,
                        description: item.id,
                        updatedBy: email
                    };
                });

                timeBased.map((item: any, index: number) => {
                    return dispatch(jobScheduleTrigger.putExtJobSchedulesRequest(item.description, item));
                })
            }

            // get triggers that are new time based jobs
            if (triggerList.length > 0) {
                const timeBased = triggerList.map((item: any, index: number) => {
                    return {
                        timezone: item.timezone ? item.timezone.replace(" UTC", "") : `${format(new Date(), 'xxx')}`,
                        cronExpression: item.cronExpression,
                        criticality: 0,
                        connectionDescription: "",
                        enabled: true,
                        endpoint: "",
                        extractTaskId: null,
                        owner: email,
                        sourceTargetName: database,
                        scheduleDescription: null,
                        taskCode: batchCode,
                        layerName: tableLayerName,
                        taskType: "Extract_Task",
                        taskDescription: null
                    };
                });

                timeBased.map((item: any, index: number) => {
                    return dispatch(jobScheduleTrigger.postExtJobSchedulesRequest(item));
                })
            }


            // get triggers that are new extractor jobs
            if (eventList.length > 0) {
                const extractors = eventList.map((ext: any) => {
                    return (
                        { description: ext.extractor[0].description, oldId: ext.id, newExtractorId: ext.extractor[0].newExtractorId }
                    )
                })
                const eventBased = extractors.map((item: any) => {
                    return {
                        eventType: "EXTRACT_TASK.SUCCESS",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "EXTRACT_TASK",
                        eventActionValue: eventTask && eventTask.length > 0 && eventTask[0].id, // Note: Get Extractor Event Task ID here
                        eventQualifier: item.newExtractorId ? item.newExtractorId : '', // Note: Set the selected extractor id value here
                        enabled: true,
                        description: item.description ? item.description : ''
                    };
                });
                eventBased.map((item: any) => {
                    return dispatch(eventBasedTrigger.postEventTriggersRequest(item));
                })
            }


            // get triggers that are existing extractor based jobs
            if (eventEditList.length > 0) {
                const extractors = eventEditList.map((ext: any) => {
                    return (
                        { description: ext.extractor[0].description, oldId: ext.id, newExtractorId: ext.extractor[0].newExtractorId }
                    )
                })
                const eventBased = extractors.map((item: any) => {
                    return {
                        eventType: "EXTRACT_TASK.SUCCESS",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "EXTRACT_TASK",
                        eventActionValue: eventTask && eventTask.length > 0 && eventTask[0].id, // Note: Get Extractor Event Task ID here
                        eventId: item.oldId ? item.oldId : '', // Note: Set existing extractor ID here
                        eventQualifier: item.newExtractorId ? item.newExtractorId : '', // Note: Set the selected extractor id value here
                        enabled: true,
                        description: item.description ? item.description : ''
                    };
                });
                eventBased.map((item: any) => {
                    return dispatch(eventBasedTrigger.putEventsRequest(item.eventId, item)); // pass the existing extractor ID here
                })
            }

            // get triggers that are new loader jobs
            if (loaderList.length > 0) {
                const loaders = loaderList.map((loader: any) => {
                    return (
                        { description: loader.loader[0].description, oldId: loader.id, newLoaderId: loader.loader[0].newLoaderId }
                    )
                })
                const loaderBased = loaders.map((item: any) => {
                    return {
                        eventType: "EXTRACT_TASK.SUCCESS",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: eventTask && eventTask.length > 0 && eventTask[0].id, // Note: Get Event Task ID here
                        eventQualifier: item.newLoaderId ? item.newLoaderId : '', // Note: Set the selected extractor id value here
                        enabled: true,
                        description: item.description ? item.description : ''
                    };
                });
                loaderBased.map((item: any) => {
                    return dispatch(eventBasedTrigger.postEventTriggersRequest(item));
                })
            }



            // get triggers that are existing loader based jobs
            if (loaderEditList.length > 0) {
                const loaders = loaderEditList.map((itm: any) => {
                    return (
                        { description: itm.loader[0].description, oldId: itm.id, newLoaderId: itm.loader[0].newLoaderId }
                    )
                })
                const loaderBased = loaders.map((item: any) => {
                    return {
                        eventType: "EXTRACT_TASK.SUCCESS",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: eventTask && eventTask.length > 0 && eventTask[0].id, // Note: Get Extractor Event Task ID here
                        eventId: item.oldId ? item.oldId : '', // Note: Set existing extractor ID here
                        eventQualifier: item.newLoaderId ? item.newLoaderId : '', // Note: Set the selected extractor id value here
                        enabled: true,
                        description: item.description ? item.description : ''
                    };
                });
                loaderBased.map((item: any) => {
                    return dispatch(eventBasedTrigger.putEventsRequest(item.eventId, item)); // pass the existing extractor ID here
                })
            }


            // get triggers that are inbound webhook based
            if (inboundWebhookList.length > 0) {
                const inboundBased = inboundWebhookList.map((item: any, index: number) => {
                    return {
                        ...item,
                        eventType: "WEB_HOOK.INBOUND",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "EXTRACT_TASK",
                        // taskCode: batchCode,
                        enabled: true,
                        description: item.webhook, // generate uuid here
                        eventActionValue: eventTask && eventTask.length > 0 && eventTask[0].id
                    };
                });

                inboundBased.map((item: any, index: number) => {
                    return dispatch(webhookAction.postInboundWebhookRequest(item));
                })
            }

            // get triggers that are existing inbound webhook based
            if (editInboundWebhookList.length > 0) {
                const inboundBased = editInboundWebhookList.map((item: any, index: number) => {
                    return {
                        eventType: "WEB_HOOK.INBOUND",
                        eventAction: "TRIGGER_TASK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: item.eventActionValue,
                        // taskCode: batchCode,
                        enabled: true,
                        description: item.webhook,
                        id: item.id
                    };
                });

                inboundBased.map((item: any, index: number) => {
                    return dispatch(webhookAction.putInboundWebhookRequest(item.id, item));
                })
            }


            // get outbound webhook actions
            if (actionList.length > 0) {

                const actionBased = actionList.map((item: any, index: number) => {
                    return {
                        ...item,
                        eventType: "LOAD_TASK.SUCCESS",
                        eventAction: "CALL_WEB_HOOK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: item.outboundWebhook,
                        eventQualifier: eventTask && eventTask.length > 0 && eventTask[0].id,
                        enabled: true,
                        header: item.header,
                        description: item.description ? item.description : '',
                    };
                });
                actionBased.map((item: any, index: number) => {
                    return dispatch(webhookAction.postOutboundWebhookRequest(item));
                })
            }



            // get outbound webhook actions
            if (editActionList.length > 0) {

                const actionBased = editActionList.map((item: any, index: number) => {
                    return {
                        ...item,
                        eventType: "LOAD_TASK.SUCCESS",
                        eventAction: "CALL_WEB_HOOK",
                        scopeType: "LOAD_TASK",
                        eventActionValue: item.outboundWebhook,
                        eventQualifier: item.eventQualifier,
                        header: item.header,
                        enabled: true,
                        description: item.description ? item.description : '',
                        id: item.id
                    };
                });
                actionBased.map((item: any, index: number) => {
                    return dispatch(webhookAction.putOutboundWebhookRequest(item.id, item));;
                })
            }

        }
    }, [extractorResult, editTriggerList, triggerList]);


    function submitTablesData(tablesData: any) {

        // extracting fields from columnGovernance for API
        const governance = tablesData.columnGovernance.map((item: any) => {
            return {
                columnId: item.srcColumnName,
                "privacyClassification": item.privacyClassification.toLowerCase(),
                "securityClassification": item.securityClassification.toLowerCase(),
                "treatmentLevel": item.treatmentLevel.toLowerCase(),
                "manualTreatment": 's',
                "ordinal": item.srcOrdinal ? item.srcOrdinal : item.id
            }
        });

        // extracting fields for S3
        tablesData.columnGovernance.map((item: any) => {
            return {
                "name": item.synColumnName,
                "dataType": item.synDataType !== undefined ? item.synDataType.toString() : '',
                "maxLength": item.synMaxLength,
                "precision": item.synPrecision,
                "scale": item.synScale,
                "ordinalPosition": item.srcOrdinal
            }
        });
        const schemaName: string = tablesData.configureTablesData.schemaName.fieldValue;
        const securityClassification: string = tablesData.configureTablesData.securityClassification.fieldValue;
        const privacyClassification: string = tablesData.configureTablesData.privacyClassification.fieldValue;
        const description: string = tablesData.configureTablesData.description.fieldValue;
        const customsql: string = tablesData.configureTablesData.customsql.fieldValue;
        const dbName: string = tablesData.database;
        const dataSteward: string = tablesData.dataSteward;
        const dataSetName: string = tablesData.configureTablesData.dataSetName.fieldValue;
        const accessControls: string = tablesData.accessControlGroup;
        const manualTreatment: string = '';
        const treatmentLevel: string = '';
        const comparisonKey = tablesData.comparisonKey;
        const extract: string = tablesData.extract ? tablesData.extract : '';
        const landing: string = tablesData.landing;
        const staging: string = "-1";
        const history: string = tablesData.history;
        const techMetadataChanged: boolean = tablesData.techMetadataChanged;
        const tableId: string = tablesData.configureTablesData.name.fieldValue;
        const tableName: string = tablesData.configureTablesData.tableName.fieldValue;
        const layerName: string = tablesData.configureTablesData.layerName.fieldValue;
        setTableLayerName(layerName);
        const fetchBatchCode: string = tablesData.batchCode;
        const eventTask = tablesData.eventTask; // has all the information for event including qualifier / actionvalue
        setEventTask(eventTask);
        setBatchCode(fetchBatchCode);


        // ***********************   STEP 1 - Setup extractor metadata ********************************

        // Setup payload for POST extractor metadata endpoint
        let metadataPayload = {
            "tableId": tableId,
            "schema": schemaName,
            "layerName": layerName,
            "businessMetadata": {
                "securityClassification": securityClassification,
                "privacyClassification": privacyClassification,
                "description": description,
                "tableName": tableName,
                "dataStewards": dataSteward,
                "dataSetName": dataSetName,
                "accessControls": accessControls,
                "manualTreatment": manualTreatment,
                "treatmentLevel": treatmentLevel,
            },
            "columnGovernanceMetadata": governance
        }
        dispatch(actions.putExtractorMetadataRequest(tableId, metadataPayload));

        // ***********************   STEP 2 - Setup extractor ********************************

        // Setup payload for DB extractor endpoint

        if ((tablesData.layerType !== constants.EXTRACT_TYPES.s3Buckets && tablesData.layerType !== constants.EXTRACT_TYPES.adls) && customsql === "") {
            if (techMetadataChanged) {
                let dbExtractorPayload = {
                    "mappingAttribute": comparisonKey.length > 0 ? comparisonKey.join(';') : null,
                    "extPattern": {
                        "selectedPatternId": extract,
                        "insertDateTime": tablesData.layerType === "EXTRACT_ORACLE" ? "TO_CHAR(SYS_EXTRACT_UTC(SYSTIMESTAMP),'YYYY-MM-DD HH24:MI:SS.FF')" : "format(SYSUTCDATETIME(),'yyyy-MM-dd HH:mm:ss.ffffff')",
                        "businessDateTime": tablesData.layerType === "EXTRACT_ORACLE" ? "" : "getdate()"
                    },
                    "lndPattern": {
                        "selectedPatternId": landing,
                    },
                    "stgPattern": {
                        "selectedPatternId": staging,
                    },
                    "hstgPattern": {
                        "selectedPatternId": history,
                    }
                }
                dispatch(dbExtractor.putExtractorRequest(fetchBatchCode, dbExtractorPayload));
            } else {
                dispatch(dbExtractor.putExtractorSkip());
            }
        }

        // if custom sql 
        if ((tablesData.layerType !== constants.EXTRACT_TYPES.s3Buckets && tablesData.layerType !== constants.EXTRACT_TYPES.adls) && customsql !== "") {
            if (techMetadataChanged) {
                let customExtractorPayload = {
                    "extPattern": {
                        "selectedPatternId": extract,
                        "insertDateTime": tablesData.layerType === "EXTRACT_ORACLE" ? "TO_CHAR(SYS_EXTRACT_UTC(SYSTIMESTAMP),'YYYY-MM-DD HH24:MI:SS.FF')" : "format(SYSUTCDATETIME(),'yyyy-MM-dd HH:mm:ss.ffffff')",
                        "businessDateTime": tablesData.layerType === "EXTRACT_ORACLE" ? "" : "getdate()"
                    },
                    "lndPattern": {
                        "selectedPatternId": landing
                    },
                    "stgPattern": {
                        "selectedPatternId": staging
                    },
                    "hstgPattern": {
                        "selectedPatternId": history
                    },
                    "mappingAttribute": comparisonKey.length > 0 ? comparisonKey.join(';') : null,
                    "customSql": customsql
                }
                dispatch(dbExtractor.putExtractorRequest(fetchBatchCode, customExtractorPayload));
            } else {
                dispatch(dbExtractor.putExtractorSkip());
            }
        }



        // Setup payload for custom extractor endpoint
        if (tablesData.layerType === constants.EXTRACT_TYPES.s3Buckets || tablesData.layerType === constants.EXTRACT_TYPES.adls) {
            if (techMetadataChanged) {
                let customExtractorPayload = {
                    "extPattern": {
                        "selectedPatternId": extract,
                        "insertDateTime": "format(SYSUTCDATETIME(),'yyyy-MM-dd HH:mm:ss.ffffff')",
                        "businessDateTime": "getdate()"
                    },
                    "lndPattern": {
                        "selectedPatternId": landing
                    },
                    "stgPattern": {
                        "selectedPatternId": staging
                    },
                    "hstgPattern": {
                        "selectedPatternId": history
                    },
                    "mappingAttribute": comparisonKey.length > 0 ? comparisonKey.join(';') : null,
                    "fileRegistration": {
                        "fieldDelimiter": tablesData?.configureTablesData?.fieldDelimiter?.fieldValue ?? ",",
                        "textDelimiter": tablesData?.configureTablesData?.textDelimiter?.fieldValue ?? "'",
                        "escapeChar": tablesData?.configureTablesData?.escapeChar?.fieldValue ?? "'",
                        "deleteFlag": tablesData?.configureTablesData?.deleteFiles?.fieldValue ?? "N",
                        "headerRows": tablesData?.configureTablesData?.headerRows?.fieldValue ?? true,
                    }
                }
                dispatch(dbExtractor.putExtractorRequest(fetchBatchCode, customExtractorPayload));
            } else {
                dispatch(dbExtractor.putExtractorSkip());
            }
        }


        // ***********************   STEP 3 - Get Batch Code and execute triggers and actions ********************************

        // get only new time based triggers
        const triggers = tablesData.triggers.filter((itm: any) => itm.cronExpression && !itm.edit)
        setTriggerList(triggers)

        // get only existing edit time based triggers
        const editTriggers = tablesData.triggers.filter((itm: any) => itm.cronExpression && itm.edit)
        setEditTriggerList(editTriggers)

        setDatabase(dbName)

        // get only new extractor based triggers 
        const eventTrigger = tablesData.triggers.filter((itm: any) => itm.extractor && !itm.edit)
        setEventList(eventTrigger)

        // get only new loader based triggers 
        const loadTrigger = tablesData.triggers.filter((itm: any) => itm.loader && !itm.edit)
        setLoaderList(loadTrigger)

        // get only existing extractor based triggers
        const eventEditTrigger = tablesData.triggers.filter((itm: any) => itm.extractor && itm.edit)
        setEditEventList(eventEditTrigger)

        // get only existing loader based triggers
        const eventLoaderTrigger = tablesData.triggers.filter((itm: any) => itm.loader && itm.edit)
        setEditLoaderList(eventLoaderTrigger)


        // get only new inbound webhook based triggers
        const inboundTrigger = tablesData.triggers.filter((itm: any) => itm.webhook && !itm.edit)
        setInboundWebhookList(inboundTrigger)


        // get only existing inbound webhook based triggers
        const editInboundTrigger = tablesData.triggers.filter((itm: any) => itm.webhook && itm.edit)
        setEditInboundWebhookList(editInboundTrigger)


        // get only new outbound action
        const outboundAction = tablesData.actions.filter((itm: any) => itm.outboundWebhook && !itm.edit)
        setActionList(outboundAction)


        // get only existing outbound action
        const outboundEditAction = tablesData.actions.filter((itm: any) => itm.outboundWebhook && itm.edit)
        setEditActionList(outboundEditAction)


        // ***********************   STEP 5 - Return some notification to tell user everything was run successfully ********************************
        alert("Extractor Data Submitted. Processing...")
    }



    return (
        <div>
            <ConfigureTablesForm submitTablesData={submitTablesData} mode="Edit" />
        </div>
    )
}
export default CreateExtractorComponent